import { render, staticRenderFns } from "./AppBurgerButton.vue?vue&type=template&id=174b13fe&scoped=true"
import script from "./AppBurgerButton.vue?vue&type=script&lang=ts"
export * from "./AppBurgerButton.vue?vue&type=script&lang=ts"
import style0 from "./AppBurgerButton.vue?vue&type=style&index=0&id=174b13fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b13fe",
  null
  
)

export default component.exports